import { LocaleLodgingTypeConfig } from "./config/lodging-type-config"
import { LocalePackConfig } from "./config/pack-config"
import {distanceSlopes} from "./data/distanceSlopes"
import {distanceCenterCity} from "./data/distanceCenterCity"
import {distanceSkiSchool} from "./data/distanceSkiSchool"
import {poi} from "./data/poi"
import {sleepingRooms} from "./data/sleepingRooms"
import { Filter } from "./types/types"

export const getFilters = (packageValues: LocalePackConfig, lodgingTypes: LocaleLodgingTypeConfig): {[filterName: string]: Filter} => {
    const filters: {[key: string]: Filter} = {
        packages: {
            items: packageValues
        },
        lodgingType: {
            items: lodgingTypes
        },
    
        // CRITERIAS NOT TRANSLATED BECAUSE THEY ARE NOT USED
        distanceSlopes: {
            label: 'Distance pistes',
            items: distanceSlopes
        },
    
        distanceCenterCity: {
            label: 'Distance centre-ville',
            items: distanceCenterCity
        },
    
        distanceSkiSchool: {
            label: 'Distance ESF',
            items: distanceSkiSchool
        },
        poi: {
            label: 'poi',
            items: poi
        },
    
        tv: {
            label: 'TV',
            criterias: ['27']
        },
        swimmingPool: {
            label: 'Piscine',
            criterias: ['74', '75', '76', '78']
        },
        balcony: {
            label: 'Balcony',
            criterias: ['29']
        },
        animalsAllowed: {
            label: 'Animaux Admis',
            criterias: ['52']
        },
        wiFi: {
            label: 'Wi-Fi',
            criterias: ['55']
        },
        cleaning: {
            label: 'Ménage',
            criterias: ['22']
        },
    
        avgRating2: {
            label: '2/5 et +',
            field: 'averageRatingMin',
            id: '2'
        },
        avgRating3: {
            label: '3/5 et +',
            field: 'averageRatingMin',
            id: '3'
        },
        avgRating4: {
            label: '4/5 et +',
            field: 'averageRatingMin',
            id: '4'
        },
        avgRating5: {
            label: '5/5',
            field: 'averageRatingMin',
            id: '5'
        },
    
        breakfast: {
            label: 'Petit<br />déjeuner',
            criterias: ['60']
        },
        fullBoard: {
            label: 'Pension<br />complète',
            criterias: ['62']
        },
        allInclusive: {
            label: 'Tout<br />inclus',
            criterias: ['63']
        },
        snowCaterer: {
            label: 'Traiteur<br />des neiges',
            criterias: ['66']
        },
    
        sleepingRooms1: {
            label: '1',
            criterias: ['339']
        },
        sleepingRooms2: {
            label: '2',
            criterias: ['340']
        },
        sleepingRooms3: {
            label: '3',
            criterias: ['341']
        },
        sleepingRooms4: {
            label: '4',
            criterias: ['342']
        },
        sleepingRooms: {
            label: '5+',
            items: sleepingRooms
        }
    }

    return filters
}